import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The one header for full-page POS screens (Cash Management, Cash Denomination, Petty Cash):
 * back button · icon · title + subtitle · projected actions on the right.
 *
 *   <app-page-header title="Petty Cash" subtitle="..." icon="pi pi-wallet" (back)="goBackToHome()">
 *     <span class="...">right-side content</span>
 *   </app-page-header>
 */
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  @Input({ required: true }) title = '';
  @Input() subtitle = '';
  /** PrimeIcons class list, e.g. "pi pi-wallet" */
  @Input() icon = '';
  @Input() showBack = true;
  @Input() backLabel = 'Back to POS';
  @Output() back = new EventEmitter<void>();
}
